import React from "react";
import { Route, RouteComponentProps } from "react-router";
import { AbsenceDay } from "../components/day/AbsenceDay";
import { RedirectToToday } from "./Redirects";

export function DayView({ match }: RouteComponentProps<{}>) {
    return (
        <div className="view view-day">
            <Route path={`${match.path}/:date`} component={DayWithDateView} />
            <Route exact path={match.path} component={RedirectToToday} />
        </div>
    );
}

function DayWithDateView({ match }: RouteComponentProps<{ date: string }>) {
    const date = new Date(match.params.date);
    return (
        <AbsenceDay date={date} bhvMode={false} />
    );
}

export function DayBhvView({ match }: RouteComponentProps<{}>) {
    return (
        <div className="view view-day">
            <Route exact path={`${match.path}`} component={DayWithDateBhvView} />
        </div>
    );
}

function DayWithDateBhvView({ match }: RouteComponentProps<{ date: string }>) {
    return (
        <AbsenceDay date={new Date()} bhvMode={true} />
    );
}
